import React, { Component } from 'react'
import ListItem from 'containers/project/list-item'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import { pickBy } from 'ramda'
import Select from 'react-select'
import SearchBar from 'components/controls/search-bar'
import { Spinner } from '@blueprintjs/core'
import { localizedDateFormatter, getUserTimeZone } from 'assets/localization'
import NoProjects from  'containers/project/no-projects'
import { axiosInstance } from 'network/apis';
import { eqSet } from 'shared/helpers/functional'

class ProjectList extends Component {

  state = {
    q: '',
    sortDir: 'desc',
    sortBy: 'modifiedDate',
    status: -1,
    creatorId: -1,
    filteredProjects: [],
    projectManagerList: [],
    projectsList: []
  }

  getProjectsRequest = async (payload) => {
    payload.id = this.props.clientId
    this.props.fetchProjectsList(payload)
  
  };
 
  componentDidMount() {
    // get projects when component mounts with selected clients and account
    if(this.props.clientsSelected && this.props.accountsSelected && !this.props.isFetchingUser) {
      this.getProjectsRequest({ clientId: this.props.clientId })
    }

    this.props.fetchProjectManager({ clientId: this.props.clientId })
  }

  debouncedSearch = debounce(this.getProjectsRequest, 400)

  filterProjects = (update) => {
    this.setState({...update})
    this.props.updateFilters({...update})
    this.debouncedSearch(pickBy(Boolean, {clientId: this.props.clientId, ...this.state, ...update}))
  }

  
  componentDidUpdate(prevProps) {
    if (prevProps.projectManagerList !== this.props.projectManagerList) {
      this.fillProjectManagerList()
    }
  }

  searchProjects = (q, projects = this.props.projectsList) => {
    if (q) {
      return projects.filter(i => {
        const re = new RegExp(q, 'i')
        return re.test(`${i.name}`) || re.test(`${i.external_survey_id}`) || re.test(`${i.salesforce_job_number}`)
      })
    }
    return []
  }

  updateAndFilter = (q = "") => {
    this.props.updateFilters({q: q})
    this.setState({
      q: q,
      filteredProjects: this.searchProjects(q, this.props.projectsList)
    })
  }

  fillProjectManagerList = () => {
    if (this.props.projectManagerList.length >= 1) {
      let formatProjectManagerList = this.props.projectManagerList
      formatProjectManagerList.unshift({ id: -1, firstName: "All", lastName: "" })
      this.setState({ projectManagerList: formatProjectManagerList })
    }
  }

  render() {
    const projects = this.props.projectsList && this.props.projectsList || []
    return (

        <div className="project-list-container">
          <div className="project-filters">
            <div className="list-name">
              <div className="name">
                My Projects
              </div>
            </div>
            <div className="flex-form">
            <SearchBar
              onChange={
                ({ currentTarget }) => this.filterProjects({q: currentTarget.value})
              }
              value={this.props.q}
            />
              <div className="filter-toggles">
                <label className="text control-label" htmlFor="status">Created By</label>
                <Select
                  value={this.props.creatorId}
                  clearable={false}
                  searchable={false}
                  onChange={({ value }) => this.filterProjects({ creatorId: value })}
                  options={this.state.projectManagerList.map(projectManager => ({value: projectManager.id , label: projectManager.firstName +" "+ projectManager.lastName}))}
                />
              </div>
            <div className="filter-toggles">
              <label className="text control-label" htmlFor="status">Status</label>
              <Select
                value={this.props.status}
                clearable={false}
                searchable={false}
                options={[{
                  value: -1,
                  label: 'All',
                }, {
                  value: 1,
                  label: 'Defining',
                }, {
                  value: 2,
                  label: 'In Progress',
                }, {
                  value: 3,
                  label: 'Complete',
                }]}
              onChange={({ value }) => this.filterProjects({ status: value })}
              />
            </div>
            <div className="filter-toggles">
              <label className="text control-label" htmlFor="sort"> Sort By </label>
              <Select
                searchable={false}
                clearable={false}
                value={this.props.sortBy}
                options={[{
                  value: 'modifiedDate',
                  label: 'Modified Date',
                }, {
                  value: 'createdDate',
                  label: 'Created Date',
                }]}
               onChange={({ value }) => this.filterProjects({ sortBy: value })}
              />
            </div>
          </div>
          </div>
        {this.props.isLoading ?
          <Spinner intent="primary" /> : this.props.projectsList && this.props.projectsList.length ?
          <div className={`list-container ${this.props.forPreview ? 'preview' : ''}`}>
            {this.props.q !== '' ? this.props.projectsList && this.props.projectsList.map((project, i) =>
              <ListItem
                {...project}
                key={i}
                toggleUploadModal={this.props.toggleUploadModal}
                formatDate={this.props.formatDate}
                timeZone={this.props.timeZone}
              />
            ) : projects.map((project, i) =>
              <ListItem
                {...project}
                key={i}
                toggleUploadModal={this.props.toggleUploadModal}
                formatDate={this.props.formatDate}
                timeZone={this.props.timeZone}
              />
            )}
          </div> : <NoProjects />
        }
        </div>
    )
  }
}

ProjectList.propTypes = {
  forPreview: PropTypes.bool,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      projectStatus: PropTypes.string,
      name: PropTypes.string,
      modifiedOn: PropTypes.string,
    })
  ),
}

const mapDispatch = dispatch => ({
  fetchProjectManager: payload => dispatch({ type: 'FETCH_ALL_PROJECT_MANAGERS_REQUESTED', payload }),
  fetchProjectsList: payload => dispatch({ type: 'FETCH_PROJECTS_LIST_REQUESTED', payload}),
  toggleUploadModal: payload => dispatch({ type: 'TOGGLE_UPLOAD_MODAL_REQUESTED', payload }),
  confirmFileUpload: () => dispatch({ type: 'SHOW_MESSAGE', payload: { message: 'Your file has been upload successfully.' } }),
  fileUploadWarning: () => ({
    type: 'SHOW_MESSAGE', payload: { message: 'There was a problem while uploading your file, please try again.' },
  }),
  updateFilters: payload => dispatch({ type: 'UPDATE_FILTERS', payload }),
})

const mapState = state => ({
  formatDate: localizedDateFormatter('en', getUserTimeZone(state)),
  clientId: state.client.clientId,
  projectManagerList: state.projectManagerList.projectManagerList,
  selectedAccount: state.user.selectedAccount,
  filteredClients: state.user.filteredClients,
  accountsSelected: state.login.accountsSelected,
  clientsSelected: state.login.clientsSelected,
  q: state.projectList.q,
  creatorId: state.projectList.creatorId,
  sortBy: state.projectList.sortBy,
  sortDir: state.projectList.sortDir,
  status: state.projectList.status,
  isLoading: state.projectList.isLoading,
  projectsList: state.projectList.projectsList,
  isFetchingUser: state.user.isFetching,
  timeZone: state.user.userInfo.timeZone
})

export default connect(mapState, mapDispatch)(ProjectList)
